import React from 'react'
import { useSelector } from 'react-redux';
import OwlCarousel from "react-owl-carousel";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css'
import useFetchPackageCategory from '../staticPackage/hooks/useFetchPackageCategory';
import { useNavigate } from 'react-router';
import noImage from "./../../assets/images/no_image_offer.jpg"


const StaticPackageDeals = () => {
    const lang = useSelector((state) => state.culture.language);
    const culture = useSelector((state) => state.culture.currentCulture);
    const navigate = useNavigate()
    const { categoryData } = useFetchPackageCategory()


    if (categoryData.length === 0) {
        return null
    }

    return (
        <section className="travel_deal_section spackageDeals">
            <div className="container">
                <div className="HMLatestFDHead">
                    <h4>{lang.plan_your_next_vacation}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <OwlCarousel
                            className="owl-theme"
                            margin={40}
                            dots

                            responsive={{
                                0: {
                                    items: 1,
                                },
                                400: {
                                    items: 1,
                                },
                                600: {
                                    items: 2,
                                },
                                700: {
                                    items: 3,
                                },
                                1000: {
                                    items: (categoryData.length > 4 ? 4 : categoryData.length),
                                }
                            }}


                        >
                            {categoryData.map((deal) => {
                                return (
                                    <div className="item" key={deal.CatagoryID} >
                                        <img src={deal.ImageUrl} alt="packageImage" onClick={() => navigate(process.env.REACT_APP_BASE_URL + culture + "/package-result")} onError={(e) => {
                                            if (e.target.src !== noImage) {
                                                e.target.src = noImage;
                                            }
                                        }} />
                                        <div className="caption d-flex">
                                            <div className="col-lg-12 p-0">
                                                <h4>
                                                    <span>{deal.Catagory[culture]}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default StaticPackageDeals